import { Route, Routes } from "react-router-dom"


import ListarUsuarios from "./ListarUsuarios"


const UsuariosRoutes = () => (
    <Routes>
        <Route path="/" Component={ListarUsuarios} />
    </Routes>
)

export default UsuariosRoutes